(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-vmc-video] button').forEach(button => {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => {
        const id = button.dataset.videoId;
        if (!/^[\w-]{11}$/.test(id || '')) return;
        const frame = document.createElement('iframe');
        frame.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
        frame.title = button.getAttribute('aria-label');
        frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        frame.allowFullscreen = true;
        button.replaceWith(frame);
        frame.focus();
      });
    });
    root.querySelectorAll('[data-vmc-scenes]').forEach(group => {
      if (group.dataset.bound) return;
      group.dataset.bound = 'true';
      group.addEventListener('toggle', event => {
        if (!(event.target instanceof HTMLDetailsElement) || !event.target.open) return;
        group.querySelectorAll('details').forEach(other => { if (other !== event.target) other.open = false; });
      }, true);
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:block:select', event => {
    const detail = event.target.closest('details');
    if (detail) detail.open = true;
  });
})();
